/* Kompaktes Pia-Panel oben auf /heute (30.10.2026): nur sichtbar, wenn der Schalter an ist und der Nutzer Pia sehen darf
   (GET /api/assistenz/status: 404 = aus, 403 = kein Zugang → nichts zeigen). Zugeklappt zeigt es die ungelesenen Nachrichten;
   aufgeklappt denselben Thread wie /pia. */
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bot, ChevronDown, ChevronUp, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import PiaThread from '@/components/PiaThread';

export default function PiaPanel() {
  const [s, setS] = useState(null);
  const [offen, setOffen] = useState(false);
  const lade = useCallback(() => api.get('/assistenz/status').then(r => setS(r.data)).catch(() => setS(null)), []);
  useEffect(() => { lade(); const t = setInterval(lade, 60000); return () => clearInterval(t); }, [lade]);
  if (!s?.aktiv) return null;
  return (
    <Card data-testid="pia-panel"><CardContent className="p-3 space-y-2">
      <div className="flex items-center justify-between gap-2">
        <button className="flex items-center gap-2 text-sm font-bold" onClick={() => setOffen(o => !o)} aria-expanded={offen}>
          <Bot className="w-4 h-4 text-marke" /> Pia
          {s.ungelesen > 0 && <span className="rounded-full bg-marke text-white text-[11px] px-1.5 py-0.5 tabular-nums" data-testid="pia-ungelesen">{s.ungelesen} neu</span>}
          {offen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
        <Link to="/pia" className="text-xs text-muted-foreground hover:underline flex items-center gap-1">Öffnen <ExternalLink className="w-3 h-3" /></Link>
      </div>
      {offen && <PiaThread darfFragen={s.darf_fragen} hoehe="h-64" onGelesen={lade} />}
    </CardContent></Card>
  );
}
